import { render, staticRenderFns } from "./separatorIcon.vue?vue&type=template&id=57e86d16&"
import script from "./separatorIcon.vue?vue&type=script&lang=js&"
export * from "./separatorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports